import * as d3 from 'd3'

export default {
  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

  methods: {
    set_LocalValues(){
      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      this.json = JSON.parse(JSON.stringify(this.JQueries))

      this.dataSet.forEach(d=> {

        let count = this.rawData.find(f=> f.IMPORT_NAME == d.name)
        count ? d.count = count.CNT : d.count = 0
        
        d.tColor = '#000'
      })

      let x_ = 0
      this.columns.forEach(d=> {
        if(d.align == 'start') d.x = x_
        if(d.align == 'middle') d.x = x_ + (d.width/2)
        if(d.align == 'end') d.x = x_ + d.width

        x_ = x_ + d.width
      })

      this.tblWidth = x_
    },
    
  }
}